import { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSwipeable } from "react-swipeable";

import moment from "../../helper/moment";
import Icon from "../Icon";
import Input from "../Input";
import { useAtom } from "jotai";
import MiniCard from "../MiniCardUI";
import { logout } from "../../api/auth";
import { colorAvatarAtom } from "../../state/constants";
import { userAtom } from "../../state/auth";
import { screenBreakpoints } from "../../config/theme";

import { ReactComponent as WomanPatient } from "../../assets/illustrations/illustration-femme-patient.svg";
import { ReactComponent as ManPatient } from "../../assets/illustrations/illustration-homme-patient.svg";

import { ReactComponent as IconSearch } from "../../assets/icons/icon-search.svg";
import EmojiSmileSick from "../../assets/images/smileSick.png";
import EmojiCamera from "../../assets/images/camera.png";
import EmojiMoney from "../../assets/images/money.png";

import "./styles.scss";

const SideBarDoctor: React.FC = () => {
  const [user] = useAtom(userAtom);
  const [patientName, setPatientName] = useState("");
  const [colorAvatar] = useAtom<any>(colorAvatarAtom);
  const [path, setPath] = useState(window.location.pathname);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [openSubmenu, setOpenSubmenu] = useState<string | null>(null);
  const [menuToggleIsActive, setMenuToggleIsActive] = useState(
    window.innerWidth <= screenBreakpoints.md
  );
  const [forceMenuOpen, setForceMenuOpen] = useState(false);

  const history = useHistory();

  const swipeEventsHandlers = useSwipeable({
    onSwipedLeft: () => {
      setForceMenuOpen(false);
    },
    onSwipedRight: () => {
      setForceMenuOpen(true);
    },
  });

  const specialistStat = [
    { name: "patients", score: "37", emoji: EmojiSmileSick, direction: "col" },
    {
      name: "revenu total",
      score: "1560 €",
      emoji: EmojiMoney,
      direction: "col",
    },
    {
      name: "télé-consultations",
      score: "41",
      emoji: EmojiCamera,
      direction: "row",
    },
  ];

  const extraMenu = () => {
    switch (path) {
      case "/specialist":
      case "/mes-patients":
        return (
          <div className="mt-2 w-full">
            <div>
              <div className="flex items-center space-x-2">
                <span className="link uppercase">quelques chiffres</span>
                <Icon isIcon={true} name={"reglage-haut_droite"} />
              </div>

              <span className="card-subtitle -mt-2 mb-2 block">
                depuis le 1er {moment().format("MMMM")}
              </span>
            </div>
            <div className="flex flex-wrap">
              {specialistStat.map(({ name, score, emoji, direction }) => (
                <MiniCard
                  name={name}
                  score={score}
                  emoji={emoji}
                  direction={direction}
                />
              ))}
            </div>
          </div>
        );

      case "/agenda":
        return <div className="border border-blue-500 h-60 w-full"></div>;
      default:
        return;
    }
  };

  const menus = [
    {
      icon: "patient-tableau",
      text: "Demandes",
      url: "/demandes",
    },
    {
      icon: "patient",
      text: "Patients",
      url: "/mes-patients",
    },
    {
      icon: "patient-tableau",
      text: "Campagnes de dépistage",
      url: "/journeesdepistage",
      //{ text: "Facturation", url: "/journéesdépistage/facturation" },
      //{ text: "Dashboard", url: "/journéesdépistage/dashboard" },
      submenu: [
        { text: "Planning", url: "/journeesdepistage/planning" },
        { text: "Clients", url: "/journeesdepistage/contributeurs" },
      ],
    },
    {
      icon: "lesSoignants",
      text: "Utilisateurs",
      url: "/users",
    },
    {
      icon: "patient",
      text: "Groupes",
      url: "/groupes",
    },
    {
      icon: "monCompte",
      text: "Mon compte",
      url: "/profile",
    },
    {
      icon: "agenda",
      text: "Disponibilités",
      url: "/disponibilités",
    },
  ];

  const handleLogout = async () => {
    try {
      await logout(user);
      setPath("/");
      window.location.href = "/";
      localStorage.clear();
    } catch (error) {
      window.location.href = "/";
      localStorage.clear();
      console.error(error);
    }
  };
  const imageBaseUrl = `${process.env.REACT_APP_KATOMI_API_URL}/v${process.env.REACT_APP_KATOMI_API_VERSION}`;

  useEffect(() => {
    setPath(window.location.pathname);

    const handleWindowResize = () => {
      setScreenWidth(window.innerWidth);
      setMenuToggleIsActive(window.innerWidth <= screenBreakpoints.md);
    };

    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  useEffect(() => {
    console.log("[debug] sidebar - ", { menuToggleIsActive });
  }, [menuToggleIsActive]);

  useEffect(() => {
    console.log("[debug] sidebar - ", { screenWidth });
  }, [screenWidth]);

  return (
    <div className="sidebar-doctor sidebar">
      <div
        className={`swipe-events-container ${
          !menuToggleIsActive || !forceMenuOpen ? "" : "swipeable-fullscreen"
        }`}
        {...swipeEventsHandlers}
      />
      <div
        className={`sidebar-container absolute transform md:relative md:translate-x-0 transition duration-200 ease-in-out ${
          menuToggleIsActive ? "mobile-sidebar" : "bg-transparent"
        } ${menuToggleIsActive && !forceMenuOpen ? "-translate-x-full" : ""}`}
      >
        <div className="relative">
          {/* <!-- SIDEBAR --> */}

          {/* mobile menu */}
          <div className="flex justify-between md:hidden absolute mobile-menu-burger">
            <button
              className="p-4 focus:outline-none"
              onClick={() => {
                setForceMenuOpen(!forceMenuOpen);
              }}
            >
              <Icon isIcon={true} name={forceMenuOpen ? "close" : "menu"} />
            </button>
          </div>
          {/* mobile menu END */}

          <div className="flex items-center space-x-3">
            {user ? (
              <div className="avatar-doctor ">
                {/* {user.picture !== null && (
                <img
                  src={`${imageBaseUrl}/${user?.picture}`}
                  alt="doctor avatar"
                  className="rounded-lg w-full h-full"
                />
              )}

              {user.picture === null && ( */}
                <div
                  className="avatar-doctor"
                  style={{ backgroundColor: colorAvatar }}
                >
                  {user?.gender === "female" ? (
                    <WomanPatient className=" rounded-lg w-full h-full -mt-2" />
                  ) : (
                    <ManPatient className=" rounded-lg w-full h-full -mt-2" />
                  )}
                </div>
                {/* )} */}
              </div>
            ) : (
              <div
                className="avatar-doctor"
                style={{ backgroundColor: colorAvatar }}
              >
                <ManPatient className="-mt-2" />
              </div>
            )}

            <div onClick={()=>console.log(user)}>
              <span className="menu">
                {user?.firstName} {user?.lastName}
              </span>
              <p className="docter-center">{user?.speciality}</p>
            </div>
          </div>

          <nav className="mt-3">
            {menus.map((menu) => {
              const isOpen = openSubmenu === menu.url;
              const hasSubmenu = !!menu.submenu;
              return (
                <div key={menu.url}>
                  {/* MAIN MENU ITEM */}
                  <div className={path.startsWith(menu.url) ? "selected-menu" : ""}>
                    <div
                      className="flex items-center space-x-3 py-3 cursor-pointer"
                      onClick={() => {
                        if (hasSubmenu) {
                          setOpenSubmenu(isOpen ? null : menu.url);
                        } else {
                          setPath(menu.url);
                          setOpenSubmenu(null);
                        }
                      }}
                    >
                      <div className="w-12 h-12 flexCenter">
                        <Icon isIcon={true} name={menu.icon} />
                      </div>

                      {hasSubmenu ? (
                        <span className="menu">{menu.text}</span>
                      ) : (
                        <Link to={menu.url} className="menu">
                          {menu.text}
                        </Link>
                      )}
                    </div>
                  </div>

                  {/* SUBMENU */}
                  {hasSubmenu && isOpen && (
                    <div className="ml-12">
                      {menu.submenu.map((sub) => (
                        <Link
                          key={sub.url}
                          to={sub.url}
                          className={`block py-2 submenu ${
                            path === sub.url ? "selected-submenu text-blue-600" : ""
                          }`}
                          onClick={() => setPath(sub.url)}
                        >
                          {sub.text}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
            
            <div className={path === "/logout" ? "selected-menu" : ""}>
              <span
                // to={"/"}
                className="flex items-center space-x-3 py-3 cursor-pointer"
                onClick={handleLogout}
              >
                <div className="w-12 h-12 flexCenter">
                  <img
                    src={require("../../assets/images/logout.png").default}
                    width="22"
                    alt="logout"
                  />
                </div>
                <span className="my-auto menu">Se déconnecter</span>
              </span>
            </div>

            {/* {extraMenu()} */}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default SideBarDoctor;
